<div class="pr-input-container">
  <span class="pr-input-label"
    >{{ label }}
    @if (
      required ||
      (control &&
        control.validator &&
        control.validator({}) &&
        control.validator({}).required)
    ) {
      <em>
        @if (!labelFinishWithSpace()) {
          <span>&#160;</span>
        }
        *</em
      >
    }
  </span>
  <span
    class="pr-input-container-control"
    [ngClass]="{ 'is-invalid': derrors && control?.errors, readonly: readonly }"
  >
    <input
      [step]="allowDecimal ? 'any' : '1'"
      type="number"
      [ngModel]="percentValue"
      [min]="minValue"
      [max]="maxValue"
      (ngModelChange)="onPercentChange($event)"
      (keydown)="onKeyDown($event)"
    />
    @if (suffix) {
      <span class="pr-input-suffix">{{ suffix }}</span>
    }
    <pr-errors [derrors]="derrors" [control]="control"></pr-errors>
  </span>
</div>
